
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

@Component
export default class RadioGroupYesNo extends Vue {
  @Prop() value!: any

  get selected() {
    return this.value
  }

  set selected(v) {
    this.$emit('input', v)
  }
}
